export { ALLOWED_BILLED_UPON, SERVICE_QUANTIFIERS } from './search-common';
export const ALLOWED_DRAFTS_AI_SEARCH_STATUS = [
    'active',
    'scheduled',
    'archived'
];
export const ALLOWED_RECURRENCE = [
    'weekly',
    'biweekly',
    'monthly',
    'quarterly',
    'yearly'
];
export const ALLOWED_PRICING_TYPE = [
    'fixed',
    'variable',
    'range',
    'hourly',
    'unitBased'
];
export const ALLOWED_DISCOUNT_TYPE = [
    'none',
    'value',
    'percent'
];
export const ALLOWED_DISCOUNT_EXPIRATION_TYPE = [
    'none',
    'period',
    'date'
];
export const ALLOWED_START_ON_TYPE = [
    'yearly',
    'yearlyEffectiveDate'
];
export const EFFECTIVE_DATE_MODES = [
    'onAcceptance',
    'specificDate'
];
